document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.tab-collage__heading[data-href]').forEach(item => {
        if (item.getAttribute('data-href')) {
            item.addEventListener('click', e => {
                window.location.href = item.getAttribute('data-href');
            });
        }
    });
    if (document.querySelector('a[href="#popup"]')) {
        document.querySelector('a[href="#popup"]').addEventListener('click', e => {
            e.preventDefault();
            if (document.querySelector('promo-popup .popup-open')) {
                document.querySelector('promo-popup .popup-open').click();
            }
        });
    }

    if (document.querySelector('.product__accordion')) {
        const accordionTabs = document.querySelectorAll('.product__accordion details');
        accordionTabs.forEach(tab => {
            tab.addEventListener('click', function () {
                // Close all other open details
                accordionTabs.forEach(item => {
                    if (item !== tab) {
                        item.removeAttribute('open');
                    }
                });
            });
        });
    }

    // const klaviyoForm = document.querySelector('#footer_klaviyo form.klaviyo-form');
    // document.querySelector('#ContactFooter-email').addEventListener('input', function(){
    //   if(klaviyoForm) {
    //     klaviyoForm.querySelector('input[type="email"]').value = this.value;
    //   }    
    // });
    // let isSubmitting = true;
    // document.querySelector('#ContactFooter').addEventListener("submit", event => {
    //   if(klaviyoForm) {
    //     klaviyoForm.querySelector('button').click();
    //   }    
    // });

    // if(document.querySelector('#form__popup_newsletter')) {
    //   document.querySelector('#form__popup_newsletter input[type="email"]').addEventListener('input', function(){
    //     if(klaviyoForm) {
    //       klaviyoForm.querySelector('input[type="email"]').value = this.value;
    //     }
    //   });
    //   document.querySelector('#form__popup_newsletter').addEventListener("submit", event => {    
    //     if(klaviyoForm) {
    //       klaviyoForm.querySelector('button').click();
    //     }
    //   });
    // }

});

// Custom delivery frequency selector for Seal Subscriptions
// document.addEventListener('DOMContentLoaded', function() {
//   // Wait for Seal app to load
//   setTimeout(function() {
//     createCustomDeliverySelector();
//   }, 1000);
// });

document.addEventListener('DOMContentLoaded', function () {
    waitForSealElements();
});


function waitForSealElements() {
    console.log('Seal elements test.');

    const maxTries = 60; // ~ 60 * 250ms = 15s
    let tries = 0;

    const timer = setInterval(() => {
        tries++;

        const existingDropdown = document.querySelector('.sls-selling-plan-group-options select');
        const sealContainer = document.querySelector('.sealsubs-target-element');

        if (existingDropdown && sealContainer) {
            clearInterval(timer);
            createCustomDeliverySelector();
            return;
        }

        if (tries >= maxTries) {
            clearInterval(timer);
            console.log('Seal elements not found after waiting.');
        }
    }, 250);
}




function createCustomDeliverySelector() {
    // Find the existing dropdown
    const existingDropdown = document.querySelector('.sls-selling-plan-group-options');
    if (!existingDropdown) return;

    // Find the Seal container to place our custom selector after it
    const sealContainer = document.querySelector('.sealsubs-target-element');
    if (!sealContainer) return;

    // Find the subscription info container to position our dropdown before it
    const subscriptionInfo = document.querySelector('.sls-more-info-container');

    // Get the available options from the existing select
    const select = existingDropdown.querySelector('select');
    if (!select) return;

    const options = Array.from(select.options).map(option => ({
        value: option.value,
        text: option.textContent.trim()
    }));

    // Create custom container
    const customContainer = document.createElement('div');
    customContainer.className = 'custom-delivery-selector';
    customContainer.style.display = 'none'; // Initially hidden

    // Build the options HTML dynamically
    const optionsHTML = options.map(option => {
        const displayText = getDisplayText(option.text);
        return `<option value="${option.value}">${displayText}</option>`;
    }).join('');

    customContainer.innerHTML = `
    <div class="delivery-selector-header">
      <label class="delivery-label">Delivery</label>
    </div>
    <div class="custom-dropdown-container">
      <select class="custom-delivery-dropdown">
        ${optionsHTML}
      </select>
      <div class="dropdown-arrow">▼</div>
    </div>
  `;

    // Hide original dropdown
    existingDropdown.style.display = 'none';

    // Insert custom selector before the subscription info (so subscription info appears last)
    if (subscriptionInfo) {
        subscriptionInfo.parentNode.insertBefore(customContainer, subscriptionInfo);
    } else {
        // Fallback: insert after the Seal container
        sealContainer.parentNode.insertBefore(customContainer, sealContainer.nextSibling);
    }

    // Add event listener to custom dropdown
    const customSelect = customContainer.querySelector('.custom-delivery-dropdown');
    customSelect.addEventListener('change', function () {
        const value = this.value;

        // Update the hidden select
        if (select) {
            select.value = value;
            select.dispatchEvent(new Event('change'));
        }
    });

    // Set initial selection
    const initialValue = select.value;
    customSelect.value = initialValue;

    // Show/hide dropdown based on subscription selection
    updateDropdownVisibility();

    // Listen for changes in subscription selection - multiple approaches
    const subscriptionRadios = document.querySelectorAll('input[name*="subs_type"]');
    subscriptionRadios.forEach(radio => {
        radio.addEventListener('change', updateDropdownVisibility);
    });

    // Also listen for clicks on the subscription option containers
    const subscriptionContainers = document.querySelectorAll('.sls-option-container[data-selling-plan-group]');
    subscriptionContainers.forEach(container => {
        container.addEventListener('click', function () {
            setTimeout(updateDropdownVisibility, 100); // Small delay to ensure radio is updated
        });
    });

    // Listen for clicks on the subscription labels
    const subscriptionLabels = document.querySelectorAll('.sls-selling-plan-group-name');
    subscriptionLabels.forEach(label => {
        label.addEventListener('click', function () {
            setTimeout(updateDropdownVisibility, 100);
        });
    });

    // Also check periodically for changes
    setInterval(updateDropdownVisibility, 500);
}

// Function to show/hide dropdown based on subscription selection
function updateDropdownVisibility() {
    const customSelector = document.querySelector('.custom-delivery-selector');
    if (!customSelector) return;

    // Check if subscription is selected - multiple approaches
    let subscriptionSelected = false;

    // Method 1: Check radio buttons
    const subscriptionRadios = document.querySelectorAll('input[name*="subs_type"]');
    subscriptionRadios.forEach(radio => {
        if (radio.checked && radio.value !== 'one_time') {
            subscriptionSelected = true;
        }
    });

    // Method 2: Check for active subscription container
    const activeSubscriptionContainer = document.querySelector('.sls-option-container.sls-active[data-selling-plan-group]');
    if (activeSubscriptionContainer) {
        subscriptionSelected = true;
    }

    // Method 3: Check if one-time purchase is NOT selected
    const oneTimeRadio = document.querySelector('input[value="one_time"]');
    if (oneTimeRadio && !oneTimeRadio.checked) {
        subscriptionSelected = true;
    }

    // Show/hide the dropdown
    customSelector.style.display = subscriptionSelected ? 'block' : 'none';

    // Debug logging
    console.log('Subscription selected:', subscriptionSelected);
    console.log('Dropdown display:', customSelector.style.display);
}

// Helper function to convert option text to display text
function getDisplayText(optionText) {
    const text = optionText.toLowerCase().trim();

    // Check for specific month counts first (most specific to least specific)
    if (text.includes('3 month')) {
        return 'Delivery every 3 Months';
    } else if (text.includes('2 month')) {
        return 'Delivery every 2 Months';
    } else if (text === 'month' || text.includes('1 month')) {
        return 'Delivery every 1 Month';
    } else if (text.includes('8 week')) {
        return 'Delivery every 8 Weeks';
    } else if (text.includes('6 week')) {
        return 'Delivery every 6 Weeks';
    } else if (text.includes('4 week')) {
        return 'Delivery every 4 Weeks';
    } else if (text.includes('3 week')) {
        return 'Delivery every 3 Weeks';
    } else if (text.includes('2 week')) {
        return 'Delivery every 2 Weeks';
    } else {
        return `Delivery every ${optionText}`;
    }
}